module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/sending-mail-9e4af1aa25152ba57b0a9b0547f66e40.svg";